<script setup>
  import { computed } from 'vue';
  import ToggleInputBooleanValue from "@/components/controls/ToggleInputBooleanValue.vue";
  import ToggleInputDefault from "@/components/controls/ToggleInputDefault.vue";

  defineEmits(['input:change']);

  const model = defineModel();

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number, Array, Object, Boolean],
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'checkbox'
    },
    trueValue: {
      type: [String, Number],
      required: false
    },
    falseValue: {
      type: [String, Number],
      required: false
    }
  });

  const attributes = computed(() => {
    return {
      id: props.id,
      name: props.name,
      value: props.value,
      disabled: props.disabled,
      inputType: props.inputType,
    };
  });

  const attributesBooleanValue = computed(() => {
    return {
      id: props.id,
      name: props.name,
      value: props.value,
      disabled: props.disabled,
      inputType: props.inputType,
      trueValue: props.trueValue,
      falseValue: props.falseValue
    };
  });

  const inputName = computed(() => props.name || props.id);
</script>

<template>
  <ToggleInputDefault
    v-if="!props.trueValue || !props.falseValue"
    @input:change="$emit('input:change', $event)"
    :attributes="attributes"
    :name="inputName"
    v-model="model"
  ></ToggleInputDefault>
  <ToggleInputBooleanValue
    v-else
    @input:change="$emit('input:change', $event)"
    @update:modelValue="$event => (model = $event)"
    :attributes="attributesBooleanValue"
    :name="inputName"
    v-model="model"
  ></ToggleInputBooleanValue>
</template>